module.exports = __webpack_public_path__ + "img/bg_rocket_launch_1920_mobile.848bdf9c.jpg";